import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { Markdown } from '@components/shared/Markdown'
import { PreWraper } from '@components/shared/wraper/PreWraper'
import { ProgramExplantion, VenueType } from '@type/buzzkuri/program-detail'
import { cloudfrontPath } from '@utils/image'
import React from 'react'
import { PopularProgramCardContentFooterItem } from '../../ProgramsSlugs/ProgramCategory/PopularProgram/CardGroup/Card/Content/Footer/Item'

type Props = ProgramExplantion & {
  venueType: VenueType
}

const VENUE_TYPE = ['online', 'offline', 'offline_and_online'] as [
  'online',
  'offline',
  'offline_and_online'
]

export const ProgramExplanation = ({
  description,
  capacity,
  requiredTime,
  venueType,
}: Props): JSX.Element => (
  <div className="w-[87.2vw] lg:w-[62.6vw]">
    <ProgramDescriptionAccordion title="本プログラムについて">
      <div className="flex flex-col py-[4vw] lg:pt-[3vw] pr-[7.5vw] lg:pr-[4.7vw] lg:pb-[4.4vw] pl-[6.1vw] lg:pl-[3.2vw] bg-[#F7F6F5]">
        <PopularProgramCardContentFooterItem
          iconPath={`${cloudfrontPath}/programs/icons/program-category/entry_number_of_people.svg`}
          text={`参加人数目安:${capacity}名`}
        />
        <div className="lg:mt-[0.8vw]">
          <PopularProgramCardContentFooterItem
            iconPath={`${cloudfrontPath}/programs/icons/program-category/duration.svg`}
            text={`所要時間:${requiredTime}分`}
          />
        </div>

        {venueType === VENUE_TYPE[0] ? (
          <div className="mt-[6vw] lg:mt-[3.1vw]">
            <PreWraper
              classes="lg:text-[16px] text-[#333333]"
              text={`本イベントはzoomを用いてのオンラインでの開催とさせて頂きます。\nzoomのURLについてはお申し込み後に、本イベントページよりアクセスが可能です。`}
            />
          </div>
        ) : venueType === VENUE_TYPE[2] ? (
          <div className="mt-[6vw] lg:mt-[3.1vw]">
            <PreWraper
              classes="lg:text-[16px] text-[#333333]"
              text={`本イベントは対面およびオンライン（zoom等使用）での開催とさせて頂きます\nzoomのURLについてはお申し込み後に、本イベントページよりアクセスが可能です。`}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="mt-[6vw] lg:mt-[3.1vw]">
          <Markdown content={description} />
        </div>
      </div>
    </ProgramDescriptionAccordion>
  </div>
)
